class AttendType {
    static ATTEND = "ATTEND";
    static NOT_SURE = "NOT_SURE";
    static ABSENT = 'ABSENT';
}

export default AttendType;